import{compareNumbersAscending as r}from"@danfoss-source/core/dist/es/utils/sort";const o=o=>[...o].sort(((o,s)=>r(o.heroOrder,s.heroOrder)));export{o as sortByHeroOrder};
